/**
 * Shared formatting and display helpers for Kasa & Bank module.
 */

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN'
  }).format(amount || 0);
};

const PAYMENT_TYPE_ICONS = {
  gotowka: 'fas fa-money-bill-wave',
  karta: 'fas fa-credit-card',
  blik: 'fas fa-mobile-alt',
  przelew: 'fas fa-university',
  kupon: 'fas fa-ticket-alt'
};

const PAYMENT_TYPE_COLORS = {
  gotowka: 'var(--success)',
  karta: 'var(--info)',
  blik: 'var(--info)',
  przelew: 'var(--purple)',
  kupon: 'var(--orange)'
};

export const getPaymentTypeIcon = (type) => {
  return PAYMENT_TYPE_ICONS[type] || 'fas fa-money-check';
};

export const getPaymentTypeColor = (type) => {
  return PAYMENT_TYPE_COLORS[type] || 'var(--text-muted)';
};

export const getOperationTypeBadge = (type) => {
  if (type === 'KP') {
    return { text: 'KP', color: 'var(--success)', bg: 'var(--success-light)' };
  }
  return { text: 'KW', color: 'var(--danger)', bg: 'var(--danger-light)' };
};

/**
 * Convert Polish diacritics to ASCII equivalents for PDF export.
 */
export const convertPolishChars = (text) => {
  if (!text) return '-';
  return text.replace(/[ąćęłńóśźż]/gi, (char) => {
    const map = {
      'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n',
      'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
      'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N',
      'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
    };
    return map[char] || char;
  });
};

/**
 * Default payment filter state - all types enabled.
 */
export const DEFAULT_PAYMENT_FILTERS = {
  gotowka: true,
  karta: true,
  blik: true,
  przelew: true,
  kupon: true
};

/**
 * Tab definitions for the main page.
 */
export const TABS = [
  { id: 'overview', label: 'Przegląd', icon: 'fas fa-chart-line' },
  { id: 'payments', label: 'Płatności', icon: 'fas fa-credit-card' },
  { id: 'all-operations', label: 'Wszystkie operacje', icon: 'fas fa-list-ul' },
  { id: 'platnosci-zmiany', label: 'Płatności zmiany', icon: 'fas fa-exchange-alt' },
  { id: 'kp', label: 'Dokumenty KP', icon: 'fas fa-plus-circle' },
  { id: 'kw', label: 'Dokumenty KW', icon: 'fas fa-minus-circle' }
];
